module.exports = __webpack_public_path__ + "img/Ellipse23.02c2c6b0.png";